export default __webpack_public_path__ + "static/media/Self Certification 7.2be42c90.pdf";